import { Injectable } from "@angular/core";
import {
	ActivatedRouteSnapshot,
	CanActivate,
	Router,
	RouterStateSnapshot,
} from "@angular/router";
import { UserService } from "../core/services/user.service";
import { isNativeIos } from "../core/utils/browser-support";

@Injectable({
	providedIn: "root",
})
export class NativeIosPublicSurfaceGuardService implements CanActivate {
	constructor(
		private userService: UserService,
		private router: Router
	) {}

	async canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	) {
		if (!isNativeIos()) {
			return true;
		}

		this.userService.requestedRoute = "";
		await this.userService.waitForAuthReady();

		const fbUser = await this.userService.afAuth.currentUser;
		if (!fbUser) {
			return this.router.createUrlTree(["/login"]);
		}

		await this.userService.ensureLoggedInUserLoaded(fbUser.uid);
		return this.router.createUrlTree(["/dashboard"]);
	}
}
